import { Flex, IconButton } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { IndicatedValue } from '../../../components/IndicatedValue.tsx';
import { SettingsControls } from '../../../components/Settings/SettingsControls.tsx';
import { featuresSelectors } from '../../../redux/features/selectors/featuresSelectors.ts';
import {
  selectHasArvOption,
  selectSalesComparisonApproach,
} from '../../../redux/features/selectors/orderSelectors.ts';
import {
  selectRegression,
  selectSensitivityAnalysis,
} from '../../../redux/features/selectors/unitRatesSelectors/selectUnitRates.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { RegressionAnalysisModal } from '../../adjustmentsGrid/modals/RegressionAnalysisModal.tsx';
import { SensitivityAnalysisModal } from '../../adjustmentsGrid/modals/SensitivityAnalysisModal.tsx';
import { EstimatedROIBanner } from '../../featureGrid/components/EstimatedROIBanner.tsx';

export const AdjustmentsModuleTitle = () => {
  const hasArvOption = useAppSelector(selectHasArvOption);
  const hasUnitRate = useAppSelector(selectSalesComparisonApproach) === 'unit_rate';

  const CostBanner = hasArvOption ? EstimatedROIBanner : IndicatedValue;

  const { selectShouldShowAdjustmentRegression } = featuresSelectors;
  const shouldShowAdjustmentRegression = useAppSelector(selectShouldShowAdjustmentRegression);
  const regression = useAppSelector(selectRegression);
  const sensitivityAnalysis = useAppSelector(selectSensitivityAnalysis);
  const isRegressionAvailable = regression?.status === 'success';
  const isSensitivityAvailable = sensitivityAnalysis !== undefined;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSensitivityModalOpen, setIsSensitivityModalOpen] = useState(false);

  if (hasUnitRate && shouldShowAdjustmentRegression) {
    return (
      <>
        <Flex justifyContent="space-between">
          <Flex gap="12px">
            <IconButton
              icon="line-chart"
              size="xs"
              iconSize="md"
              ariaLabel="Open regression analysis model"
              text="Regression Model"
              textColor="buttonDefault"
              variant="secondary"
              __dangerDoNotUseSx={{ width: 'fit-content' }}
              disabled={!isRegressionAvailable}
              onClick={() => setIsModalOpen(true)}
            />
            <IconButton
              icon="speedometer"
              size="xs"
              iconSize="md"
              ariaLabel="Open sensitivity analysis model"
              text="Sensitivity Model"
              textColor="buttonDefault"
              variant="secondary"
              __dangerDoNotUseSx={{ width: 'fit-content' }}
              disabled={!isSensitivityAvailable}
              onClick={() => setIsSensitivityModalOpen(true)}
            />
          </Flex>
          <Flex alignItems="center" gap=".75rem">
            <SettingsControls />
          </Flex>
        </Flex>
        <RegressionAnalysisModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        <SensitivityAnalysisModal
          isOpen={isSensitivityModalOpen}
          onClose={() => setIsSensitivityModalOpen(false)}
        />
      </>
    );
  }

  return (
    <Flex
      marginBottom=".5rem"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      <CostBanner />
      <SettingsControls />
    </Flex>
  );
};
